import React from 'react';
import { NewLandingPage } from './pages/NewLandingPage';
// Google Tag Manager noscript fallback component
const GTMNoScript = () => <noscript data-id="element-0" data-mp="35bsf2xftp6t8">
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KSNWGS2V" height="0" width="0" style={{
    display: 'none',
    visibility: 'hidden'
  }} data-id="element-1" data-mp="35c29cx7wi04q" />
  </noscript>;
export function App() {
  return <>
      <GTMNoScript data-id="element-2" data-mp="2rk47n7gir6il" />
      <NewLandingPage data-id="element-3" data-mp="2rlox4inz7z9l" />
    </>;
}